import React, { useEffect } from 'react';
import { BlueLinkButton, HelpFeaturedContainer } from './components';
import { LOGIN_ROUTES } from './constants';

export const LoginError: React.FC = () => {
	useEffect(() => {
		localStorage.clear();
	}, []);
	return (
		<HelpFeaturedContainer>
			<h1>Something went wrong</h1>
			<p>
				We were not able to log you in. <br />
				Please contact support, or you can try again:
			</p>
			<div>
				<BlueLinkButton id="try-again-btn" to={LOGIN_ROUTES.EMAIL}>
					Try again
				</BlueLinkButton>
			</div>
		</HelpFeaturedContainer>
	);
};
